export const _N4RUD3 = [
  { label: "OVERVIEW", path: "/class/dashboard/overview" },
  { label: "STUDENTS", path: "/class/dashboard/students" },
  { label: "TEACHERS", path: "/class/dashboard/teachers" },
  { label: "SUBJECTS", path: "/class/dashboard/subjects" },
  { label: "ANNOUNCEMENTS", path: "/class/dashboard/announcements" },
];
